import React from 'react';
import { Search } from '../../types/search.types';
import { useNavigate } from 'react-router-dom';

interface SearchesTableProps {
  searches: Search[];
}

const SearchesTable: React.FC<SearchesTableProps> = ({ searches }) => {
  const navigate = useNavigate();
  console.log('begining');
  console.log('SearchesTable: Received searches:', searches, 'Type:', typeof searches, 'IsArray:', Array.isArray(searches));

  if (!searches || !Array.isArray(searches) || searches.length === 0) {
    return <p className="text-sm text-gray-600">No searches found.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              ID
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Query
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Location
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden sm:table-cell"
            >
              Status
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell"
            >
              Progress
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden lg:table-cell"
            >
              Created At
            </th>
             <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {searches.map((search) => {
            try {
              return (
                <tr key={search.id}>
                  <td className="px-3 py-2 whitespace-nowrap text-xs font-medium text-gray-900">
                    {search.id}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700">
                    {search.search_query}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700">
                    {search.city_name}, {search.state_name}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700 hidden sm:table-cell">
                    {search.status}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700 hidden md:table-cell">
                    {search.progress ? search.progress.toFixed(1) : 'N/A'}%
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-700 hidden lg:table-cell">
                    {new Date(search.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-blue-600 hover:underline cursor-pointer">
                    <span onClick={() => navigate(`/admin/searches/${search.id}`)}>View</span>
                  </td>
                </tr>
              );
            } catch (error) {
              console.error('SearchesTable: Error rendering search row:', search, error);
              return (
                <tr key={search.id || 'error'}>
                  <td colSpan={7} className="px-3 py-2 text-xs text-red-600">
                    Error rendering search data
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SearchesTable; 